import React, {Component} from 'react';
import SectionBanner from 'components/section-banner';
import SectionTitle from 'components/section-title';
import OptionsSidebar from 'components/options-sidebar';
import styles from './styles.css';

export default class RTIMultiplierHome extends Component {
    render() {
        return (
            <div className={styles.root}>
                <SectionBanner />
                <SectionTitle title='RTI' />
                <div className={styles.gridContainer}>
                    <OptionsSidebar refundType='rti' userType='multiplier' links={['refund', 'kits']} />
                    <div className={styles.message}>
                        <p>Realizá tu pedido</p>
                        <p>Para garantizar la entrega correcta del kit de materiales se debe solicitar con 10 días
                         hábiles de anticipación
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/refunds/rti-multiplier/home/index.js